// this file is automatically generated by git.revision.js script
export const versions = { revision: '5326d1035f' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '5326d1035f';
